import { render } from "./Gallery.vue?vue&type=template&id=b436139c"
import script from "./Gallery.js?vue&type=script&lang=js"
export * from "./Gallery.js?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__